/**
 * The collections a card's own content lives in, beside the `cards` document itself. All four are
 * queried by `cardId` today, so the field is always there to filter on.
 */
export const CARD_SCOPED_COLLECTIONS = ['tasks', 'card-chat-messages', 'card-attachments', 'history-items'];

/**
 * @param {String} cardId Card being translated.
 * @returns {String} Id of that card's Translation activation. It carries `cardId` because card
 * dialogs stack - a single shared id would have the second card's scope replace the first card's.
 */
export const translationId = (cardId) => `card-translate-${cardId}`;

/**
 * The activation's scope: this card's own document, the documents carrying its `cardId`, and the
 * board tags and column the card shows. Tags and the column are board-wide documents, so the
 * translation also reads on the board behind the card while it is open; closing the card puts
 * them back.
 *
 * @param {String} cardId Card being translated.
 * @param {Object} refs
 * @property {Array} refs.tagIds Ids of the card's tags in `board-tags`.
 * @property {String} refs.columnId Id of the card's column.
 * @returns {Function} `(doc, collection) => Boolean` for `translation.start`.
 */
export const cardScopeFilter = (cardId, { tagIds = [], columnId } = {}) => (doc, collection) =>
  (collection === 'cards' && doc.id === cardId) ||
  (CARD_SCOPED_COLLECTIONS.includes(collection) && doc.cardId === cardId) ||
  (collection === 'board-tags' && tagIds.includes(doc.id)) ||
  (collection === 'columns' && doc.id === columnId);
